const models = [
    {
        id: 1,
        name: 'David McHenry'
    },
    {
        id: 2,
        name: 'Frank Kirk'
    },
    {
        id: 3,
        name: 'Rafael Morales'
    },
    {
        id: 4,
        name: 'Mark Ellison'
    },
    {
        id: 5,
        name: 'Minnie Walter'
    },
    {
        id: 6,
        name: 'Shirley Smith'
    },
    {
        id: 7,
        name: 'John Santiago'
    },
    {
        id: 8,
        name: 'Colin Melton'
    },
];

export { models };
